import { IIndustryEvents } from "../models/IIndustryEvents";

export default function getIndustryEvents(
  contentId: number,
  page: number = 1,
  businessArea: string,
  eventType: Array<string>,
  region: Array<string>,
  search: string,
  dateFrom: string,
  dateTo: string
): Promise<IIndustryEvents> {
  const params = {
    contentId,
    page,
    businessArea,
    eventType,
    region,
    search,
    dateFrom,
    dateTo
  };

  return fetch("/api/IndustryEventsApi/GetData", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(params)
  })
    .then((e) => e.json())
    .then((result) => result);
}
